import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductSelectionPartsModel } from "@tCooneyBrothers/ApiModels";
import ProductSelectionPartsState from "@tCooneyBrothers/Store/Data/ProductSelectionParts/ProductSelectionPartsState";
import { Draft } from "immer";

const initialState: ProductSelectionPartsState = {
    isLoading: false,
    value: [],
};

const reducer = {
    "Data/ProductSelectionParts/BeginLoadProductSelectionParts": (draft: Draft<ProductSelectionPartsState>) => {
        draft = {
            isLoading: true,
        };
    },
    "Data/ProductSelectionParts/CompleteLoadProductSelectionParts": (
        draft: Draft<ProductSelectionPartsState>,
        payload: { action: ProductSelectionPartsModel[] },
    ) => {
        draft.value = payload.action;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
